import React from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

const ShortProductOne = () => {

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    arrows: true,
                },
            },

        ],

    };
    return (
    <div className="short-product">
        <div className="container container-lg">
            <div className="row gy-4">
                <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 ">
                        <div className="p-16 bg-main-50 rounded-16 mb-32">
                            <h6 className="underlined-line position-relative mb-0 pb-16 d-inline-block">
                                Featured Plants
                            </h6>
                        </div>
                        <div className="short-product-list arrow-style-two">
                            <Slider {...settings}>
                                <div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img1.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.1k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Monstera Deliciosa Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹29.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹45.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img2.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(1.8k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Snake Plant Laurentii
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹19.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹32.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img3.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(3.4k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Fiddle Leaf Fig Tree
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹49.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹69.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img4.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.7</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(950)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    String of Pearls
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹15.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹22.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img1.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(1.2k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Peace Lily Spathiphyllum
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹24.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹34.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img2.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.7k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Bonsai Japanese Juniper
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹39.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹55.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img3.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(1.5k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Aloe Vera Medicinal Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹12.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹18.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img4.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(3.1k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Rubber Plant Ficus Elastica
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹34.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹49.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 ">
                        <div className="p-16 bg-main-50 rounded-16 mb-32">
                            <h6 className="underlined-line position-relative mb-0 pb-16 d-inline-block">
                                Top Selling Plants
                            </h6>
                        </div>
                        <div className="short-product-list arrow-style-two">
                            <Slider {...settings}>
                                <div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img5.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(5.2k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Monstera Deliciosa Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹29.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹45.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img6.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(4.1k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Snake Plant Laurentii
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹19.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹32.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img7.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(6.3k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Fiddle Leaf Fig Tree
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹49.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹69.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img8.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.7</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.8k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    String of Pearls
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹15.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹22.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img5.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(3.5k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Peace Lily Spathiphyllum
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹24.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹34.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img6.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(4.2k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Bonsai Japanese Juniper
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹39.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹55.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img7.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.9k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Aloe Vera Medicinal Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹12.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹18.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img8.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(5.1k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Rubber Plant Ficus Elastica
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹34.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹49.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 ">
                        <div className="p-16 bg-main-50 rounded-16 mb-32">
                            <h6 className="underlined-line position-relative mb-0 pb-16 d-inline-block">
                                On-Sale Plants
                            </h6>
                        </div>
                        <div className="short-product-list arrow-style-two">
                            <Slider {...settings}>
                                <div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img9.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(1.9k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Pothos Golden Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹11.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹18.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img4.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.7</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(1.2k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    ZZ Plant Zamioculcas
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹21.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹34.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img7.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.3k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Spider Plant Chlorophytum
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹9.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹15.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img4.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(1.6k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Jade Plant Crassula
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹14.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹22.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img9.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(1.4k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Calathea Orbifolia
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹27.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹42.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img4.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.7</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(980)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Chinese Evergreen
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹18.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹28.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img7.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.1k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Philodendron Brasil
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹16.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹24.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img4.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(1.7k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Dracaena Marginata
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹31.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹47.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 ">
                        <div className="p-16 bg-main-50 rounded-16 mb-32">
                            <h6 className="underlined-line position-relative mb-0 pb-16 d-inline-block">
                                Top Rated Plants
                            </h6>
                        </div>
                        <div className="short-product-list arrow-style-two">
                            <Slider {...settings}>
                                <div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img3.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">5.0</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(4.8k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Orchid Phalaenopsis
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹32.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹49.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img7.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(3.2k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Lavender Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹12.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹18.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img1.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.9k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Rosemary Herb Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹8.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹14.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img8.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.2k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Fern Boston Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹17.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹26.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img1.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(3.7k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Mint Plant
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹6.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹11.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img7.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(2.4k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Cactus Mix Collection
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹24.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹35.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16 mb-40">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img3.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">5.0</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(5.2k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Venus Fly Trap
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹19.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹29.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-align gap-16">
                                        <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                            <Link to="/product-details" className="link">
                                                <img
                                                    src="assets/images/thumbs/short-product-img8.png"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">4.9</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">(3.9k)</span>
                                            </div>
                                            <h6 className="title text-lg fw-semibold mt-8 mb-8">
                                                <Link to="/product-details" className="link text-line-1">
                                                    Parlor Palm
                                                </Link>
                                            </h6>
                                            <div className="product-card__price flex-align gap-8">
                                                <span className="text-heading text-md fw-semibold d-block">
                                                    ₹22.99
                                                </span>
                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                                                    ₹33.99
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)
}

export default ShortProductOne